import PropTypes from 'prop-types';
import { OPTION_ICONS } from '../../../helpers/account-helper';
import * as Styled from './Style';
const {
  I18n
} = global;
const SegmentOptions = ({
  options,
  isIconShow = false
}) => {
  if (!(options && options.length)) {
    return null;
  }
  const renderOption = (option, idx) => {
    const text = I18n.t('components.SegmentOptions')[option.replace(/-/g, '_')];
    return /*#__PURE__*/React.createElement(Styled.Option, {
      key: `segment-option${idx}`
    }, isIconShow && /*#__PURE__*/React.createElement("span", {
      className: `icon icon-${OPTION_ICONS[option]}`
    }), /*#__PURE__*/React.createElement("span", null, text));
  };
  return /*#__PURE__*/React.createElement(Styled.ListUnstyled, null, /*#__PURE__*/React.createElement(Styled.Title, null, I18n.t('components.SegmentOptions.title')), options.map((option, idx) => renderOption(option, idx)));
};
SegmentOptions.propTypes = {
  options: PropTypes.array,
  isIconShow: PropTypes.bool
};
export default SegmentOptions;